import { useNavigate } from "react-router-dom";
import { Zap } from "lucide-react";

const NAV_LINKS = [
  { label: "Modules", href: "#modules" },
  { label: "Socratic AI", href: "#socratic" },
  { label: "Parent Portal", href: "#parents" },
  { label: "Curriculum", href: "#curriculum" },
  { label: "FAQ", href: "#faq" },
];

export default function LandingHeader() {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-background/85 border-b border-border" data-testid="landing-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
        <div className="flex items-start gap-2.5 select-none" data-testid="landing-brand-logo">
          <img
            src="https://customer-assets-jai6qajn.emergentagent.net/job_student-genius-26/artifacts/kbshcq5q_Branding-02.png"
            alt="SmartGuru Logo Icon"
            className="h-9 w-9 sm:h-11 sm:w-11 object-contain shrink-0 mt-0.5"
            data-testid="brand-logo-icon"
          />
          <div className="flex flex-col">
            <p className="font-heading font-extrabold text-2xl sm:text-3xl tracking-tight bg-gradient-to-r from-[#9A3DB2] via-[#4F4CB9] to-[#E73F9A] bg-clip-text text-transparent leading-none" data-testid="brand-wordmark">SmartGuru.io</p>
            <p className="font-notebook text-xs sm:text-sm text-foreground/80 font-semibold mt-0.5 whitespace-nowrap" data-testid="brand-tagline">
              Your Smarter Way to Learn.
            </p>
          </div>
        </div>
        <nav className="hidden lg:flex items-center gap-6">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`landing-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors"
            >
              {l.label}
            </a>
          ))}
          <button onClick={() => navigate("/contact")} data-testid="landing-nav-contact" className="text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors">
            Contact
          </button>
        </nav>
        <div className="flex items-center gap-3 sm:gap-4 shrink-0">
          <button
            onClick={() => navigate("/login")}
            data-testid="landing-header-login-button"
            className="text-sm font-bold text-foreground hover:text-primary transition-colors"
          >
            Log In
          </button>
          <button
            onClick={() => navigate("/onboarding")}
            data-testid="landing-header-cta"
            className="flex items-center gap-2.5 shrink-0"
          >
            <span className="hidden md:inline-flex items-center gap-1 bg-accent/15 text-accent border border-accent/30 rounded-full px-2.5 py-1 text-[11px] font-bold" data-testid="header-trial-badge">
              <Zap size={11} /> 7-Day Free Trial
            </span>
            <span className="bg-primary text-primary-foreground font-bold text-sm px-4 sm:px-5 py-2.5 rounded-full hover:bg-primary/90 active:scale-95 transition-all">
              Try Free
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}
